import React from 'react';

import { contentOptimizerLSTabKey } from '../../../../../../constants/contentOptimizer';
import { contentOptimizerContentTabValues } from '../../contentOptimizerContentConstants';
import BriefTabContent from './content/BriefTabContent';

import './BriefTab.scss';

const BriefTabContainer = () => {
    const mainOptimizerTab = localStorage.getItem(contentOptimizerLSTabKey);

    if (mainOptimizerTab !== contentOptimizerContentTabValues.brief.value) {
        return null;
    }

    return <BriefTabContent />;
};

export default BriefTabContainer;
